import React from "react";
import { motion } from "framer-motion";
import { Smartphone, UserCheck, Users2, TrendingUp, Wallet } from "lucide-react";

const highlights = [
  { icon: Smartphone, value: "5.1M+", label: "App Installs", sub: "Strong user acquisition across multiple platforms" },
  { icon: UserCheck, value: "1.24M+", label: "Registrations", sub: "Growing trust. Expanding reach." },
  { icon: Users2, value: "350K+", label: "Interested Leads", sub: "High intent. Quality leads driving our pipeline." },
  { icon: Wallet, value: "165K+", label: "Demat Accounts", sub: "Enabling financial growth for thousands." },
  { icon: TrendingUp, value: "40K+", label: "Active Traded", sub: "Real engagement. Real transactions." },
];

export default function Highlights() {
  return (
    <section id="results" className="relative py-32 overflow-hidden">
      <div className="aurora bg-[#C9A227] w-[520px] h-[520px] -top-40 right-0" style={{opacity:0.18}} />
      <div className="aurora bg-[#047857] w-[420px] h-[420px] bottom-0 -left-20" style={{opacity:0.15}} />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto">
          <span className="eyebrow">Performance Highlights</span>
          <h2 className="mt-6 text-4xl md:text-6xl font-semibold">
            Delivering <span className="text-gold-gradient">measurable results.</span><br />
            Driving <span className="text-emerald-gradient">real impact.</span>
          </h2>
          <p className="mt-6 text-white/60 text-lg">
            Performance across Finance, Insurance, Gaming, FinTech, Education, E-commerce and Consumer Brands.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {highlights.map((h, i) => (
            <motion.div
              key={h.label}
              initial={{opacity:0, y:24}}
              whileInView={{opacity:1, y:0}}
              viewport={{once:true}}
              transition={{duration:0.6, delay: i*0.08, ease:[0.16,1,0.3,1]}}
              className="glass rounded-2xl p-6 relative overflow-hidden card-lift"
            >
              <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-[#C9A227]/10 blur-2xl" />
              <h.icon size={22} className="text-[#F4D983]" />
              <div className="mt-5 text-3xl md:text-4xl font-semibold text-gold-gradient">{h.value}</div>
              <div className="mt-2 text-sm font-medium text-white/80">{h.label}</div>
              <div className="mt-2 text-xs text-white/50 leading-relaxed">{h.sub}</div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
          {["Direct Execution","Quality Focused","Data Driven","Performance Optimized","Results Delivered"].map(t=>(
            <span key={t} className="text-xs uppercase tracking-[0.24em] px-4 py-2 rounded-full border border-white/10 text-white/60 bg-white/[0.02]">{t}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
